import React from 'react';
import PropTypes from 'prop-types';

import styles from './Checkbox.module.scss';
import cn from '../../../utils/tools/cn';

function Checkbox({
  id, isChecked, onChange, children, disabled,
}) {
  return (
    <label htmlFor={id} className="d-flex a-center c-pointer">
      <div className={cn([styles.box_wrapper])}>
        <input id={id} checked={isChecked} type="checkbox" onChange={onChange} disabled={disabled} />
        <span className={cn([styles.box, 'd-flex center'])} />
      </div>
      {children}
    </label>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  isChecked: false,
  onChange: () => {},
  children: null,
  disabled: false,
};

export default Checkbox;
